import React from 'react'
import PropTypes from 'prop-types'
import { Column, Columns } from 'react-flex-columns'

import InputRangePicker from './InputRangePicker'

import styles from '../scss/ui/inputRangeWrap.scss'

const InputRangeWrap = ({ labelA, labelB, desc, ...rest }) => (
    <div className={styles.inputRangeWrap}>
        <h3>
            <Columns split gutterSize={2}>
                <Column>{ labelA }</Column>
                <Column className="right-content">{ labelB }</Column>
            </Columns>
        </h3>
        <InputRangePicker {...rest} />
    </div>
)

InputRangeWrap.defaultProps = {
    desc: '', labelA: 'add me!', labelB: 'add me too!',
}

InputRangeWrap.propTypes = {
    labelA: PropTypes.string,
    labelB: PropTypes.string,
    desc: PropTypes.string,
    max: PropTypes.number.isRequired,
    min: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.number.isRequired,
}

export default InputRangeWrap



// WEBPACK FOOTER //
// ./src/ui/InputRangeWrap.js